const styleTemplate = `
.hero {
    position: relative;
    overflow: hidden;
    height: /@heroImage.height.desktop@/;

    @include respond(medium) {
        height: /@heroImage.height.tablet@/;
    }
}

.image {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: /@heroImage.background@/;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.hotelDetails {
    position: absolute;
    bottom: 0;
    max-width: /@heroImage.hotelDetails.maxWidth@/;
    padding: 1rem;
    background: /@heroImage.hotelDetails.background@/;
    color: /@heroImage.hotelDetails.color@/;
    font-weight: /@heroImage.hotelDetails.fontWeight@/;

    a {
        color: /@heroImage.hotelDetails.link.color@/;
        font-weight: /@heroImage.hotelDetails.link.fontWeight@/;

        &:hover {
            color: /@heroImage.hotelDetails.link.color@/;
        }
    }
}

.hotelName {
    margin-bottom: 1rem;
    @include respond(smallMedium) {
        margin-bottom: 0;
    }
}

.address,
.phone,
.reservation,
.website {
    margin-bottom: 1rem;

    &:before {
        vertical-align: top;
        font-size: 1.2rem;
        margin-right: 0.5rem;
    }

    @include respond(smallMedium) {
        display: none;
    }
}

.address {
    @include icon($hotel);

    span {
        display: inline-block;
    }

    .addressLine {
        display: block;
    }
}

.phone {
    @include icon($phone);
}

.reservation {
    @include icon($note);
}

.website {
    @include icon($link);
}
`;

export default styleTemplate;



// WEBPACK FOOTER //
// ./src/components/ngbe_base/hero-image/hero-image-template.js